const settingsOptions = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SIDE_OPTIONS':
            return {
                ...state,
                options: action.payload
            };
        case 'SET_CURRENT_SIDE':
            return {
                ...state,
                currentSide: action.payload
            };
        default:
            return state;
    }
};

export default settingsOptions;
